var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Menu',{attrs:{"mode":"vertical","theme":"light","active-name":_vm.$route.name}},[_c('left-menu-item',{attrs:{"routes":_vm.$router.options.routes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }